import { compose } from 'recompose';
import { NumberShim } from '@packages/helpers/core/shims/number-shim';

export const mapDepositSavings = goals => {
  const { depositPercent, propertyPrice } = goals;

  return {
    ...goals,
    depositSavings: NumberShim.percentIs(depositPercent, propertyPrice)
  };
};

export const mapLoanAmount = goals => {
  const { depositSavings, propertyPrice } = goals;

  return {
    ...goals,
    loanAmount: propertyPrice - depositSavings
  };
};

export const mapMortgageTerm = goals => {
  const { mortgageTerm } = goals;

  return {
    ...goals,
    mortgageTermYears: Math.trunc(mortgageTerm / 12)
  };
};

export const calculateMaxValues = goals => {
  const { depositSavings, propertyPrice } = goals;

  const maxPropertyPrice = (depositSavings * 100) / 5;
  const maxDepositSavings = (propertyPrice * 95) / 100;

  return {
    ...goals,
    maxPropertyPrice,
    maxDepositSavings,
    propertyPrice: propertyPrice < maxPropertyPrice ? propertyPrice : maxPropertyPrice,
    depositSavings: depositSavings < maxDepositSavings ? depositSavings : maxDepositSavings
  };
};

const mapDepositPercent = goals => {
  const { depositSavings, propertyPrice } = goals;

  return {
    ...goals,
    depositPercent: NumberShim.percentOf(depositSavings, propertyPrice)
  };
};

export const calculateGoals = compose(mapLoanAmount, mapMortgageTerm, calculateMaxValues, mapDepositPercent);

export const calculateMortgage = compose(mapLoanAmount, mapMortgageTerm, calculateMaxValues, mapDepositSavings);

export const processLoanAmount = (loanAmount = 0) => (loanAmount <= 0 ? 0 : Math.trunc(loanAmount));
